import { loaders } from 'entities';

import { LabeledSelect } from 'components/Blocks';

import { sortByName } from 'utils/array';

interface Props {
  team: string;
  setTeam: (team: string) => void;
}

export function TeamSelect({ team, setTeam }: Props) {
  const { data: teams, loading } = loaders.teams.list.use({
    defaultValue: [],

    parser: (teams) => sortByName(teams.filter(({ canAssumeProject }) => canAssumeProject)),

    refreshMinutes: 20,
  });

  return (
    <LabeledSelect
      options={teams}
      value={team}
      onChangeDirect={setTeam}
      loading={loading}
      labelKey="name"
      anchorTo="body"
    />
  );
}
